// warehouse-log-type.js
import { WarehouseLogType } from '@/services/resources'

export default {
  data () {
    return {
      warehouseLogTypes: [] // 分类列表数据
    }
  },
  mounted () {
    this.getWarehouseLogTypes()
  },
  methods: {
    getWarehouseLogTypes () { // 获取分类列表数据
      WarehouseLogType.query().then(({ data }) => {
        this.warehouseLogTypes = data
      })
    }
  }
}
